import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { EvaluableProp, withEvaluators } from "../../../withEvaluators";
import { withResolvePaths } from "../../../withResolvePaths";
import { withViewModelSelect } from "../../../withViewModelSelect";

import { StickyTableBodyColumn, StickyTableBodyColumnProps } from "./StickyTableBodyColumn";

interface StickyTableBodyColumnContainerProps extends StickyTableBodyColumnProps {
    condition?: EvaluableProp<boolean>;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: StickyTableBodyColumnContainerProps) => ({
    visible: ownProps.condition == undefined ? true : ownProps.processEvaluableProp(state, ownProps.condition),
});

export const StickyTableBodyColumnContainer = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps)(StickyTableBodyColumn)))
);
